export default __webpack_public_path__ + "static/media/f17b175e-3266-43fb-b785-fe992817ef2d.b649caf6.jpg";